import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'controllo-costi-per-missione';
export const ENTITY_PLURAL = 'Controllo costi per missione';
export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Codice missione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'missione.codice',
  },
  {
    elementLabel: 'Descrizione missione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'missione.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Codice programma',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'programma.codice',
  },
  {
    elementLabel: 'Descrizione programma',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'programma.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Codice piano dei conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.codice',
  },
  {
    elementLabel: 'Descrizione piano dei conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Tipo',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    initialHideColumn: true,
    exportHideColumn: true,
    field: 'tipo',
    sortable: true,
  },
  {
    elementLabel: 'Movimenti Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'totaleMovimentiDare',
    sortable: true,
  },
  {
    elementLabel: 'Movimenti Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'totaleMovimentiAvere',
    sortable: true,
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
